module.exports = __webpack_public_path__ + "img/195.7aca90d9.jpg";